import { deserialize, serializable } from 'serializr';

export class UsedExecutionTimeModel {
  @serializable
  public tenantId: number;
  @serializable
  public month: string;
  @serializable
  public testsigmaLabTime: number;
  @serializable
  public localDeviceTime: number;
  @serializable
  public browserStackTime: number;
  @serializable
  private sauseLabTime: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(UsedExecutionTimeModel, input));
  }
}
